angular.module 'zc.projects'

.service 'chartConfig', ($filter) ->

  # analytics
  main:
    options:
      title:
        text: null
      tooltip:
        shared: true
        crosshairs: true
        dateTimeLabelFormats:
          hour: $filter('translate')('sharedModules.dateTimeFormats.chart.monthDayHour')
          day: $filter('translate')('sharedModules.dateTimeFormats.chart.monthDay')
      credits:
        enabled: false
      legend:
        enabled: false
      plotOptions:
        series:
          marker:
            radius: 3
            fillColor: '#FFF'
            lineWidth: 2,
            lineColor: null
      yAxis:
        min: 0

  # analytics
  pie:
    options:
      chart:
        plotBackgroundColor: null
        plotBorderWidth: 0
        plotShadow: false
      title:
        align: 'center'
        verticalAlign: 'middle'
        y: -20
      credits:
        enabled: false
      legend:
        floating: true
        y: -140
        borderColor: "#fff"
      tooltip:
        pointFormat: "<b>{point.percentage:.1f}%</b>"
      plotOptions:
        pie:
          showInLegend: true
          startAngle: -90
          endAngle: 90
          dataLabels:
            enabled: true
            distance: -50
            style:
              fontWeight: "bold"
              color: "white"
              textShadow: "0px 1px 2px black"
    series: []

  # line chart style
  line:
    options:
      title:
        text: null
      credits:
        enabled: false
      colors: ['#26c9ff', '#666666']
      chart:
        type: 'line'
      tooltip:
        shared: true
        crosshairs: true
        dateTimeLabelFormats:
          hour: $filter('translate')('sharedModules.dateTimeFormats.chart.monthDayHour')
          day: $filter('translate')('sharedModules.dateTimeFormats.chart.monthDay')
      plotOptions:
        series:
          marker:
            symbol: 'circle'
            enabled: false
      xAxis:
        type: 'datetime'
        dateTimeLabelFormats:
          hour: $filter('translate')('sharedModules.dateTimeFormats.chart.hour')
          day: $filter('translate')('sharedModules.dateTimeFormats.chart.monthDay')
      yAxis:
        title:
          text: null
        min: 0
        labels:
          formatter: ->
            # get value suffix from series
            prefix = @chart.series[0].tooltipOptions.valuePrefix or ''
            suffix = @chart.series[0].tooltipOptions.valueSuffix or ''
            valueDecimals = @chart.series[0].tooltipOptions.valueDecimals or 0
            prefix + Highcharts.numberFormat(this.value, valueDecimals) + suffix
    series: []

  # base chart
  base:
    xAxis:
      type: 'datetime'
      minRange: 24 * 3600000
    yAxis:
      title:
        text: ''
      plotLines: [
        value: 0
        width: 1
        color: '#808080'
      ]
    series: []
    legend:
      align: 'center'
      verticalAlign: 'bottom'
      borderWidth: 0

  # Column chart
  column:
    options:
      title:
        text: null
      colors: ['#26c9ff']
      chart:
        type: 'column'
      legend: false
    xAxis:
      type: 'datetime'
      minRange: 24 * 3600000
    yAxis:
      title:
        text: ''
    series: []

  # area chart
  area:
    options:
      chart:
        type: 'area'
    xAxis:
      type: 'datetime'
      minRange: 24 * 3600000
    yAxis:
      title:
        text: ''
      plotLines: [
        value: 0
        width: 1
        color: '#808080'
      ]
    series: []
    legend:
      align: 'center'
      verticalAlign: 'bottom'
      borderWidth: 0

  campaignPriceDistribution:
    options:
      title:
        text: null
      colors: ['#26c9ff']
      chart:
        type: 'column'
      legend: false
    yAxis:
      plotLines: [
        value: 0
        color: '#808080'
      ]
    series: []

  campaignInterestWidgetItembution:
    options:
      title:
        text: null
      colors: ['#26c9ff', '#666666']
      chart:
        type: 'column'
      legend: false
      credits:
        enabled: false
    yAxis:
      min: 0
      title:
        text: ''
      labels:
        formatter: ->
          # get value suffix from series
          prefix = @chart.series[0].tooltipOptions.valuePrefix or ''
          suffix = @chart.series[0].tooltipOptions.valueSuffix or ''
          valueDecimals = @chart.series[0].tooltipOptions.valueDecimals or 0
          prefix + Highcharts.numberFormat(this.value, valueDecimals) + suffix
    series: []

  campaignDwell:
    options:
      title:
        text: null
      colors: ['#26c9ff']
      chart:
        type: 'spline'
      legend: false
      credits:
        enabled: false
    xAxis:
      title:
        text: ''
      labels:
        format: '{value}' + $filter('translate')('sharedModules.common.unit.minute')
    yAxis:
      min: 0
      title:
        text: ''
      plotLines: [
        value: 0
        color: '#808080'
      ]
      labels:
        format: '{value}' + $filter('translate')('sharedModules.common.unit.session')
    series: []

  campaignHistoryCount:
    options:
      title:
        text: null
      colors: ['#26c9ff']
      chart:
        type: 'spline'
      legend: false
      credits:
        enabled: false
    xAxis:
      title:
        text: ''
      labels:
        format: '{value}' + $filter('translate')('sharedModules.common.unit.pv')
    yAxis:
      min: 0
      title:
        text: ''
      plotLines: [
        value: 0
        color: '#808080'
      ]
      labels:
        format: '{value}' + $filter('translate')('sharedModules.common.unit.session')
    series: []

  report:
    options:
      title:
        text: null
      chart:
        type: 'area'
      legend:
        enabled: false
      plotOptions:
        series:
          marker:
            symbol: 'circle'
            enabled: false
      xAxis:
        type: 'datetime'
        dateTimeLabelFormats:
          day: $filter('translate')('sharedModules.dateTimeFormats.chart.monthDay')
      yAxis:
        title:
          text: null
        min: 0
        labels:
          formatter: ->
            # get value suffix from series
            prefix = @chart.series[0].tooltipOptions.valuePrefix or ''
            suffix = @chart.series[0].tooltipOptions.valueSuffix or ''
            valueDecimals = @chart.series[0].tooltipOptions.valueDecimals or 0
            prefix + Highcharts.numberFormat(this.value, valueDecimals) + suffix

  segment:
    options:
      title:
        text: null
      colors: ['#26c9ff', '#666666']
      chart:
        type: 'area'
      legend:
        enabled: false
      credits:
        enabled: false
      tooltip:
        shared: true
        crosshairs: true
        dateTimeLabelFormats:
          hour: $filter('translate')('sharedModules.dateTimeFormats.chart.monthDayHour')
          day: $filter('translate')('sharedModules.dateTimeFormats.chart.monthDay')
      plotOptions:
        series:
          marker:
            symbol: 'circle'
            enabled: false
      xAxis:
        type: 'datetime'
        dateTimeLabelFormats:
          day: $filter('translate')('sharedModules.dateTimeFormats.chart.monthDay')
      yAxis:
        title:
          text: null
        min: 0
        labels:
          formatter: ->
            # get value suffix from series
            prefix = @chart.series[0].tooltipOptions.valuePrefix or ''
            suffix = @chart.series[0].tooltipOptions.valueSuffix or ''
            valueDecimals = @chart.series[0].tooltipOptions.valueDecimals or 0
            prefix + Highcharts.numberFormat(this.value, valueDecimals) + suffix



// WEBPACK FOOTER //
// ../enterprise/src/zenclerk_modules/projects/constants/chart_config.js.coffee